export * from './accessorial-detail.component';
